module.exports = __webpack_public_path__ + "img/03.7d5b4a28.png";